export default __webpack_public_path__ + "static/media/stock-issues.42c7561f.svg";